"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  "use strict";

  var moduleName = "common";
  var componentName = "selectInsurerDocs";

  var bindings = {
    docs: "=?"
    // onChange: '&?'
  };

  var templateUrl = "app/common/component/selectInsurerDocs/selectInsurerDocs.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($scope, $element, $timeout, CustomListsService) {
      _classCallCheck(this, Controller);

      this.$scope = $scope;
      this.$timeout = $timeout;
      this.element = $($element);
      this.CustomListsService = CustomListsService;
    }

    _createClass(Controller, [{
      key: "$onInit",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var typeDocUser, typeDocVehicle, typeDocDamage, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, list, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, doc;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (_typeof(this.docs) != "object") {
                    this.docs = {};
                  }
                  console.log("insurerDocs=", this.docs);

                  _context.next = 4;
                  return this.CustomListsService.getSelectArray("typeDocUser");

                case 4:
                  typeDocUser = _context.sent;
                  _context.next = 7;
                  return this.CustomListsService.getSelectArray("typeDocVehicle");

                case 7:
                  typeDocVehicle = _context.sent;
                  _context.next = 10;
                  return this.CustomListsService.getSelectArray("typeDocDamage");

                case 10:
                  typeDocDamage = _context.sent;


                  this.docsLists = [];
                  this.docsLists.push({
                    name: "typeDocDamage",
                    label: "Sinistre",
                    values: typeDocDamage.filter(function (doc) {
                      return doc.value === "DO3";
                    } // Constat amiable
                    )
                  });
                  this.docsLists.push({
                    name: "typeDocVehicle",
                    label: "Véhicule",
                    values: typeDocVehicle.filter(function (doc) {
                      return doc.value === "V1";
                    } // Carte grise
                    )
                  });
                  this.docsLists.push({
                    name: "typeDocUser",
                    label: "Collaborateur",
                    values: typeDocUser.filter(function (doc) {
                      return doc.value === "U1" || doc.value === "U1B";
                    } // Permis de conduire Recto et Verso
                    )
                  });

                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context.prev = 18;
                  _iterator = this.docsLists[Symbol.iterator]();

                case 20:
                  if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                    _context.next = 45;
                    break;
                  }

                  list = _step.value;

                  if (!this.docs[list.name]) {
                    this.docs[list.name] = {};
                  }

                  _iteratorNormalCompletion2 = true;
                  _didIteratorError2 = false;
                  _iteratorError2 = undefined;
                  _context.prev = 26;
                  for (_iterator2 = list.values[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    doc = _step2.value;

                    if (!this.docs[list.name][doc.value]) {
                      if (doc.value === "DO3") {
                        // Constat amiable
                        this.docs[list.name][doc.value] = {
                          copy: true,
                          mandatory: false
                        };
                      } else {
                        this.docs[list.name][doc.value] = {
                          copy: false,
                          mandatory: false
                        };
                      }
                    } else if (doc.value === "DO3") {
                      // Constat amiable : toujours forcer copy à true
                      this.docs[list.name][doc.value].copy = true;
                    }
                  }
                  _context.next = 34;
                  break;

                case 30:
                  _context.prev = 30;
                  _context.t0 = _context["catch"](26);
                  _didIteratorError2 = true;
                  _iteratorError2 = _context.t0;

                case 34:
                  _context.prev = 34;
                  _context.prev = 35;

                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }

                case 37:
                  _context.prev = 37;

                  if (!_didIteratorError2) {
                    _context.next = 40;
                    break;
                  }

                  throw _iteratorError2;

                case 40:
                  return _context.finish(37);

                case 41:
                  return _context.finish(34);

                case 42:
                  _iteratorNormalCompletion = true;
                  _context.next = 20;
                  break;

                case 45:
                  _context.next = 51;
                  break;

                case 47:
                  _context.prev = 47;
                  _context.t1 = _context["catch"](18);
                  _didIteratorError = true;
                  _iteratorError = _context.t1;

                case 51:
                  _context.prev = 51;
                  _context.prev = 52;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 54:
                  _context.prev = 54;

                  if (!_didIteratorError) {
                    _context.next = 57;
                    break;
                  }

                  throw _iteratorError;

                case 57:
                  return _context.finish(54);

                case 58:
                  return _context.finish(51);

                case 59:

                  this.$timeout(function () {}, 0);
                  console.log("docsLists=", this.docsLists);

                case 61:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[18, 47, 51, 59], [26, 30, 34, 42], [35,, 37, 41], [52,, 54, 58]]);
        }));

        function $onInit() {
          return _ref.apply(this, arguments);
        }

        return $onInit;
      }()
    }, {
      key: "change",
      value: function change() {
        console.log("docs", this.docs);
      }
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    transclude: true,
    controller: Controller
  });
})();